import { useState } from 'react';
import { LuLogOut } from 'react-icons/lu';

import { AppAccountButton } from '@frontend/App/Account/App.AccountButton';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@frontend/components/ui/avatar';
import { Button } from '@frontend/components/ui/button';
import { Popover, PopoverContent } from '@frontend/components/ui/popover';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@frontend/components/ui/tooltip';
import { useDirectoryMe } from '@frontend/shared/hooks/useDirectory';
import { redirectToLogin } from '@frontend/shared/util/util.redirectToLogin';

export function AppAccount() {
  const me = useDirectoryMe();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <AppAccountButton isOpen={isOpen} onToggle={() => setIsOpen(!isOpen)} />
      <PopoverContent align="end" side="top" className="w-80">
        <div className="flex items-center border-b pb-3">
          <Avatar className="h-9 w-9">
            <AvatarImage src={me.image} alt={me.name} />
            <AvatarFallback>{me.name?.[0]}</AvatarFallback>
          </Avatar>
          <h3 className="ml-2 text-sm font-semibold">{me.name}</h3>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="sm"
                  className="ml-auto"
                  onClick={() => {
                    redirectToLogin('goToHome');
                  }}
                  aria-label="Logout"
                >
                  <LuLogOut className="h-5 w-5" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Log out</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div className="pb-10 pt-3">
          <h4 className="mt-6 text-xs font-medium text-primary">
            Contact support
          </h4>
          <Button
            variant="link"
            asChild
            className="h-auto p-0 text-primary hover:underline"
          >
            <a
              target="_blank"
              href="mailto:help@questionbase.com"
              rel="noopener noreferrer"
            >
              help@questionbase.com
            </a>
          </Button>
          <h4 className="mt-6 text-xs font-medium text-primary">
            Free personal onboarding
          </h4>
          <Button
            variant="link"
            asChild
            className="h-auto p-0 text-primary hover:underline"
          >
            <a
              target="_blank"
              href={`https://cal.com/team/questionbase/demo-call-from-slack?name=${encodeURIComponent(me.name || '')}&email=${encodeURIComponent(me.email || '')}`}
              rel="noopener noreferrer"
            >
              Book a call
            </a>
          </Button>
          <h4 className="mt-6 text-xs font-medium text-primary">Feedback</h4>
          <Button
            variant="link"
            asChild
            className="h-auto p-0 text-primary hover:underline"
          >
            <a
              target="_blank"
              href="https://forms.gle/3o6z1w74Ke4NHaMN9"
              rel="noopener noreferrer"
            >
              Send feedback
            </a>
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
